import React, { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

function Particle() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tsparticles"
      className="particle-canvas"
      init={particlesInit}
      options={{
        background: { color: { value: "transparent" } },
        fpsLimit: 60,
        particles: {
          number: { value: 80, density: { enable: true, area: 900 } },
          color: { value: "#c770f0" },
          opacity: { value: 0.15, random: true },
          size: { value: { min: 1, max: 3 }, random: true },
          move: {
            enable: true,
            speed: 0.4,
            direction: "none",
            outModes: { default: "out" },
          },
          links: {
            enable: true,
            distance: 140,
            color: "#c770f0",
            opacity: 0.08,
            width: 1,
          },
        },
        interactivity: {
          events: {
            onHover: { enable: true, mode: "grab" },
          },
          modes: {
            grab: { distance: 150, links: { opacity: 0.2 } },
          },
        },
        detectRetina: true,
      }}
    />
  );
}

export default Particle;
